// Ejecutar cuando el DOM esté completamente cargado
document.addEventListener('DOMContentLoaded', function () {
  // Reglas de cantidad mínima por SKU (100 o 50 unidades)
  const minQtyBySku = [
    { sku: 'AFT00029', minQty: 100 },
    { sku: 'AFT00003', minQty: 100 },
    { sku: 'AFT00002', minQty: 100 },
    { sku: 'AFT00018', minQty: 100 },
    { sku: 'AFT00030', minQty: 100 },
    { sku: 'AFT00001', minQty: 100 },
    { sku: 'AFT00017', minQty: 100 },
    { sku: 'AFT00009', minQty: 100 },
    { sku: 'AFT00004', minQty: 100 },
    { sku: 'AFT00006', minQty: 100 },
    { sku: 'AFT00012', minQty: 100 },
    { sku: 'AFT00028', minQty: 100 },
    { sku: 'AFT00014', minQty: 100 },
    { sku: 'AFT00027', minQty: 100 },
    { sku: 'AFT00015', minQty: 100 },
    { sku: 'AFT00005', minQty: 100 },
    { sku: 'AFT00022', minQty: 100 },
    { sku: 'AFT00016', minQty: 100 },
    { sku: 'AFT00031', minQty: 100 },
    { sku: 'AFT00021', minQty: 100 },
    { sku: 'AFT00010', minQty: 100 },
    { sku: 'AFT00025', minQty: 100 },
    { sku: 'AFT00020', minQty: 100 },
    { sku: 'AFT00007', minQty: 100 },
    { sku: 'AFT00023', minQty: 100 },
    { sku: 'AFT00026', minQty: 100 },
    { sku: 'AFT00011', minQty: 100 },
    { sku: 'AFT00024', minQty: 100 },
    { sku: 'AFT00008', minQty: 100 },
    { sku: 'AFT00019', minQty: 100 },
    { sku: 'AFR00054', minQty: 50 },
    { sku: 'AFR00055', minQty: 50 }
  ];

  // Selecciona el formulario del carrito
  const cartForm = document.querySelector('form[action="/cart"]');

  // Función que aplica las reglas de cantidad mínima a los ítems del carrito
  function enforceRules() {
    const cartItems = document.querySelectorAll('tr.cart-item'); // Cada fila del carrito
    cartItems.forEach(itemRow => {
      const input = itemRow.querySelector('input[name="updates[]"]'); // Input de cantidad
      const sku = input?.dataset.sku; // SKU del producto, guardado en data-sku
      const rule = minQtyBySku.find(item => item.sku === sku); // Busca si hay una regla para este SKU
      
      if (!input || !sku || !rule) return;

      const value = parseInt(input.value); // Cantidad actual
      if (isNaN(value) || value < rule.minQty) {
        input.value = rule.minQty; // Ajusta automáticamente si es menor al mínimo
      }
    });
  }

  // Revisa el carrito cada 200ms para detectar manipulaciones externas (scripts, extensiones, etc.)
  setInterval(enforceRules, 200);

  // Antes de enviar el formulario, se valida que no haya productos con cantidad menor al mínimo
  if (cartForm) {

    // Evento que se dispara al intentar enviar el formulario del carrito
    cartForm.addEventListener('submit', function (e) {
      let bloqueado = false; // Bandera para saber si hay cantidades inválidas
      const cartItems = document.querySelectorAll('tr.cart-item');  // Selecciona todas las filas de productos en el carrito

      // Recorre cada producto del carrito
      cartItems.forEach(itemRow => {
        const input = itemRow.querySelector('input[name="updates[]"]'); // Input de cantidad por ítem
        const sku = input?.dataset.sku; // Extrae el SKU desde el atributo data-sku
        const rule = minQtyBySku.find(item => item.sku === sku); // Busca si ese SKU tiene una regla

        // Si existe una regla para el SKU actual
        if (rule) {
          const value = parseInt(input.value); // Convierte el valor a número entero
          if (isNaN(value) || value < rule.minQty) {
            input.value = rule.minQty; // Corrige la cantidad por la cantidad mínima requerida
            bloqueado = true; // Activa la bandera de bloqueo para evitar el envío
          }
        }
      });

      if (bloqueado) {
        e.preventDefault(); // Evita que el formulario se envíe
        // alert('Uno o más productos requieren al menos 100 unidades.'); // Mensaje de advertencia
      }
    });
  }
});